import { cn } from "@gymflow/helpers";
import { AlertTriangleIcon } from "apps/portal/src/components/atoms";

type WarningBlockProps = {
  text: string;
  className?: string;
};

export const WarningBlock = ({ text, className }: WarningBlockProps) => (
  <div
    className={cn(
      "bg-warning-100 dark:bg-warning-900 flex items-start gap-2 rounded-lg px-3 py-1.5",
      className,
    )}
  >
    <div className="my-1">
      <AlertTriangleIcon
        className="size-4"
        pathClassName="stroke-warning-700 dark:stroke-warning-500"
      />
    </div>
    <div className="text-warning-700 dark:text-warning-25 text-sm font-medium">
      {text}
    </div>
  </div>
);
